export enum ShopItemProductVariant {
	Default = 'default',
	Large = 'large',
}

export const shopItemProductImageSize: Record<
	ShopItemProductVariant,
	number | 'lg'
> = {
	[ShopItemProductVariant.Default]: 'lg',
	[ShopItemProductVariant.Large]: 120,
};
